import React, { useMemo, useState } from "react";
import { UploadDocumentDocuTypeEnum } from "../../api-client";
import {
  FormControlLabel,
  Grid,
  List,
  ListItem,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";

export interface DocumentTypeSelectProps {
  selectedDocuType: UploadDocumentDocuTypeEnum | null;
  onSelectDocumentType: (documentType: UploadDocumentDocuTypeEnum) => void;
}
export default function DocumentTypeSelect({
  onSelectDocumentType,
  selectedDocuType,
}: DocumentTypeSelectProps) {
  const docuTypes = useMemo(() => {
    const docuValues = Object.values(UploadDocumentDocuTypeEnum);
    return docuValues.map((docuType) => (
      <FormControlLabel
        key={docuType}
        control={<Radio sx={{ padding: "6px" }} />}
        label={docuType}
        value={docuType}
      />
    ));
  }, [UploadDocumentDocuTypeEnum]);

  return (
    <>
      <Typography variant="subtitle1">Dokumenttyp auswählen:</Typography>
      <RadioGroup
        // sx={{ display: "flex", padding: "4px", margin: "3px" }}
        value={selectedDocuType}
        onChange={(e: any) => onSelectDocumentType(e.target.value)}
        aria-label="selectedDocuType"
        name="selectedDocuType"
      >
        {docuTypes}
      </RadioGroup>
    </>
  );
}
